import {Component, OnInit} from '@angular/core';
import {AuditingService} from "../../services/auditing.service";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {ErrorHandlingService} from "../../services/error-handling.service";
import {ContainerComponent} from "@coreui/angular";
import {FailedAuditsTableComponent} from "../../components/audit-tables/failed-audits-table/failed-audits-table.component";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-error-debugging',
  templateUrl: './error-debugging.component.html',
  standalone: true,
  imports: [
    ContainerComponent,
    FailedAuditsTableComponent
  ],
  styleUrls: ['./error-debugging.component.css']
})
export class ErrorDebuggingComponent implements OnInit {

  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateForTemplate = UIStateEnum;

  constructor(private auditingService: AuditingService,
              private errorHandlingService: ErrorHandlingService) {
  }

  ngOnInit(): void {
    forkJoin([
      this.auditingService.retrieveAllEventTypes(),
      this.auditingService.retrieveErrorTypes()
    ]).subscribe({
      next: () => this.uiState = UIStateEnum.ShowData,
      error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
